import {EntityService} from "@/model/service/entity-service"
import {Country} from "@/model/entity/country/country"
import {AxiosPromise} from "axios"

class CountryService extends EntityService<Country> {
  constructor() {
    super("country", Country)
  }

  create(entity: Country): AxiosPromise<Country> {
    return super.create(entity).then(response => {
      refreshList()
      return response
    })
  }

  modify(entity: Country): AxiosPromise<Country> {
    return super.modify(entity).then(response => {
      refreshList()
      return response
    })
  }
}

export interface ICountryService extends EntityService<Country> {
}

const list: Country[] = []

const service = new CountryService()

function refreshList(): void {
  service.getAll().then(response => response.data.forEach(element => {
    element.i18nKey = "entity.country." + element.isoCodeAlpha2
    list.push(element)
  }))
}

refreshList()

export const countryService = service

export const countryList = list
